import { render } from "./statistics_page.vue?vue&type=template&id=0b8aff06&scoped=true"
import script from "./statistics_page.vue?vue&type=script&lang=js"
export * from "./statistics_page.vue?vue&type=script&lang=js"

import "./statistics_page.vue?vue&type=style&index=0&id=0b8aff06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8aff06"]])

export default __exports__